import React, { Component } from 'react';
import Highcharts from 'highcharts';
import WordCloud from 'highcharts/modules/wordcloud';
import ReactHighcharts from 'react-highcharts';
import Exporting from 'highcharts/modules/exporting';

WordCloud(Highcharts);
Exporting(Highcharts);

Highcharts.seriesTypes.wordcloud.prototype.spirals.archimedean = (t, params) => {
  const e = params.field.width / (params.field.height);

  return {
    x: e * (t *= .1) * Math.cos(t),
    y: t * Math.sin(t)
  };
};

const chartImageCache = {};

export default class HighCharts extends Component {
  state = {};

  componentDidMount() {
    const { config, image } = this.props;

    if (image && this.refs.chart) {
      chartImageCache[JSON.stringify(config)] = this.refs.chart.getChart().getSVG();
      this.forceUpdate();
    }
  }

  get innerHTML() {
    return {
      __html: chartImageCache[JSON.stringify(this.props.config)]
    }
  }

  get hasImage() {
    return chartImageCache[JSON.stringify(this.props.config)];
  }

  render() {
    const { image } = this.props;

    if (image && this.hasImage) {
      return <div dangerouslySetInnerHTML={this.innerHTML} />
    }

    return (
      <ReactHighcharts ref="chart" {...this.props} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/highcharts.js